module.exports = __webpack_public_path__ + "img/03.30f813b2.jpg";